import React from 'react';
import {Player} from 'video-react';
import '../../assets/css/video-react.css';
class Info extends React.Component{


  constructor(props){
   super(props)
   this.state={
       name:""
   }
  }

  //<source src='https://media.w3.org/2010/05/sintel/trailer_hd.mp4'/>

  render(){

    return(
        <div>
          我是用户信息组件
          <Player ref="player" videoId="video-1" >
         
           <source src='http://ali-play.lezhibo.com/lezhibo/6d4a32ddd48a491baab7467e68307661.m3u8'/>
          </Player>
        </div>
    )
  }
}

export default Info;


// WEBPACK FOOTER //
// ./src/components/User/Info.js